import {LanguageService} from "../service/LanguageService";

/** @ngInject */
export default function(languageService: LanguageService) {
    languageService.init();
}
